// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip_icon__N319+","tooltip-text":"Tooltip_tooltip-text__UCCHo"};